import './engines.component.scss'

import $ from 'jquery'

$(document).ready(function () {
  $('.engines__details').click(function () {
    $(this).parents('.engines').toggleClass('engines--expand');
  });
});